import {z as r} from 'zod';

/**
 * Single help_links row: exact `urlPattern` match via `useHelpLink(key, true)`.
 * Put URLs in `config` JSON on that row.
 */
/** Exact `urlPattern` on help_links (see `isMatchingHelpLink` with `isConfigLink: true`). */
export const LEGAL_DOCUMENTATION_CONFIG_LINK_KEY = 'cp-config-link-legal-documentation';

export const legalDocumentationHelpLinkConfigSchema = r.object({
    mailingsConsent: r.string().optional(),
    privacyPolicy: r.string().optional(),
    terms: r.string().optional(),
});

export type LegalDocumentationHelpLinkConfigType = r.infer<typeof legalDocumentationHelpLinkConfigSchema>;

export function parseLegalDocumentationHelpLinkConfig(raw: unknown): LegalDocumentationHelpLinkConfigType | null {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
        return null;
    }

    const parsed = legalDocumentationHelpLinkConfigSchema.safeParse(raw);

    return parsed.success ? parsed.data : null;
}
